/**
 * External dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockProps,
	__experimentalUnitControl as UnitControl // eslint-disable-line
} from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';

export default ( { attributes: { inputborderradius, responsiveonlyicon }, setAttributes } ) => {
	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: 'suredash-portal__editor-search',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<UnitControl
						label={ __( 'Input Roundness', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="100px"
						value={ inputborderradius }
						onChange={ ( inputborderradius ) => setAttributes( { inputborderradius } ) } // eslint-disable-line
					/>
					<ToggleControl
						label={ __( 'Show only Icon on Responsive', 'suredash' ) }
						checked={ responsiveonlyicon }
						onChange={ ( responsiveonlyicon ) => setAttributes( { responsiveonlyicon } ) } // eslint-disable-line
					/>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<div id="portal-placeholder-search-wrap" className="portal-search-container portal-header-search-trigger portal-content">
					<input itemProp="query-input" type="search" id="placeholder-search-input" className="portal-search-input" placeholder={ __( 'Search', 'suredash' ) } style={ { borderRadius: inputborderradius } } />
					<label id="pf_docs-button-holder" className="pf-svg-search pfd-svg-icon pf-docs-search-button" htmlFor="placeholder-search-input"> {/* eslint-disable-line */}
						<span className="portal-svg-icon portal-icon-sm">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
						</span>
					</label>
					<span className="portal-search-shortcut">/</span>
				</div>
			</div>
		</>
	);
};
